export const iconFontAwesomeHumanitarianVolcano = (
	<i className="fa-solid fa-volcano"></i>
);
